<!-- card 6 -->
<div
  class="w-full rounded border border-[#e0e6ed] bg-white p-5 shadow-[4px_6px_10px_-3px_#bfc9d4] dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none"
>
  <div class="text-[#515365] dark:text-white-light">
    <form class="space-y-5" [formGroup]="form">

      <div>
        <label for="code">Code:</label>
        <input id="code" type="text" placeholder="Enter Code" class="form-input" formControlName="code" />
        <form-error [form]="form" controlName="code" [validations]="MasterMerchantFormValidations.code"></form-error>
      </div>
      <div>
        <label for="name">Name:</label>
        <input id="name" type="text" placeholder="Enter Name" class="form-input" formControlName="name" />
        <form-error [form]="form" controlName="name" [validations]="MasterMerchantFormValidations.name"></form-error>
      </div>

      <div>
        <label for="user">User:</label>
        <input id="user" type="text" placeholder="Enter User" class="form-input" formControlName="user" />
        <form-error [form]="form" controlName="user" [validations]="MasterMerchantFormValidations.user"></form-error>
      </div>

      <div>
        <label for="password">Password:</label>
        <input id="password" type="text" placeholder="Enter Password" class="form-input" formControlName="password" />
        <form-error [form]="form" controlName="password"
                    [validations]="MasterMerchantFormValidations.password"></form-error>
      </div>

      <div>
        <label for="secret_code">Secret Code:</label>
        <input id="secret_code" type="text" placeholder="Enter Secret Code" class="form-input"
               formControlName="secret_code" />
        <form-error [form]="form" controlName="secret_code"
                    [validations]="MasterMerchantFormValidations.secret_code"></form-error>
      </div>

      <div>
        <label for="callback_url">Callback URL:</label>
        <input id="callback_url" type="text" placeholder="Enter Callback URL" class="form-input"
               formControlName="callback_url" />
        <form-error [form]="form" controlName="callback_url"
                    [validations]="MasterMerchantFormValidations.callback_url"></form-error>
      </div>

      <div>
        <label for="expired_date">Expired Date</label>
        <ng2-flatpickr
          #expiredDatePicker
          formControlName="expired_date"
          [config]="expiredDateConfig"
          addClass="form-input">
        </ng2-flatpickr>
      </div>

      <div>
        <!--        <label for="payment_type">Payment Type:</label>-->
        <!--        <input id="payment_type" type="text" placeholder="Enter Payment Type" class="form-input" formControlName="payment_type" />-->
        <!--        <form-error [form]="form" controlName="payment_type" [validations]="MasterMerchantFormValidations.payment_type"></form-error>-->
        <label>Payment Type:</label>
        <ng-select
          [items]="paymentTypeOption"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Payment Type"
          class="custom-multiselect w-full"
          formControlName="payment_type"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="payment_type"
          [validations]="MasterMerchantFormValidations.payment_type"></form-error>
      </div>

      <div>
        <label for="balance">Balance:</label>
        <input id="balance" type="number" placeholder="Enter Balance" class="form-input" formControlName="balance" />
        <form-error [form]="form" controlName="balance"
                    [validations]="MasterMerchantFormValidations.balance"></form-error>
      </div>

      <div>
        <label for="bank_account">Bank Account:</label>
        <input id="bank_account" type="text" placeholder="Enter Bank Account" class="form-input"
               formControlName="bank_account" />
        <form-error [form]="form" controlName="bank_account"
                    [validations]="MasterMerchantFormValidations.bank_account"></form-error>
      </div>

      <div>
        <label for="bank_name">Bank Name:</label>
        <input id="bank_name" type="text" placeholder="Enter Bank Name" class="form-input"
               formControlName="bank_name" />
        <form-error [form]="form" controlName="bank_name"
                    [validations]="MasterMerchantFormValidations.bank_name"></form-error>
      </div>

      <div>
        <label for="bank_branch">Bank Branch:</label>
        <input id="bank_branch" type="text" placeholder="Enter Bank Branch" class="form-input"
               formControlName="bank_branch" />
        <form-error [form]="form" controlName="bank_branch"
                    [validations]="MasterMerchantFormValidations.bank_branch"></form-error>
      </div>

      <div>
        <label for="add_params1">Additional Parameter 1:</label>
        <input id="add_params1" type="text" placeholder="Enter Additional Parameter 1" class="form-input"
               formControlName="add_params1" />
        <form-error [form]="form" controlName="add_params1"
                    [validations]="MasterMerchantFormValidations.add_params1"></form-error>
      </div>

      <div>
        <label for="add_params2">Additional Parameter 2:</label>
        <input id="add_params2" type="text" placeholder="Enter Additional Parameter 2" class="form-input"
               formControlName="add_params2" />
        <form-error [form]="form" controlName="add_params2"
                    [validations]="MasterMerchantFormValidations.add_params2"></form-error>
      </div>


      <button
        [disabled]="form.invalid"
        type="button"
        class="btn btn-success mt-4 w-full md:w-[180px]"
        (click)="saveData()"
      >
        <span
          *ngIf="loading"
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span>
        Submit
      </button>
    </form>
  </div>
</div>
